import api from '@app/apiExternalStorage'
import { CONTENT_TYPES } from '@app/api/constants'
import { handleS3AxiosError, S3Error } from '@app/utils/s3ErrorHandler'

export interface UploadDataParams {
  url: string
  data: FormData
}

export const uploadData = async ({ url, data }: UploadDataParams): Promise<void> => {
  const headers = { 'Content-Type': CONTENT_TYPES.multipartFormData }
  const config = { headers }

  try {
    const response = await api.post(url, data, config)

    if (response.status >= 300) {
      const s3Error = new S3Error({
        status: response.status,
        code: 'HTTPError',
        message: `HTTP ${response.status}: ${response.statusText}`,
        userMessage: `Ошибка загрузки файла: HTTP ${response.status}`
      })
      throw s3Error
    }
  } catch (error) {
    if (error instanceof Error && 'response' in error) {
      const s3Error = handleS3AxiosError(error as any)
      if (s3Error) {
        throw s3Error
      }
    }

    if (error instanceof S3Error) {
      throw error
    }

    throw error
  }
}
